import { render, staticRenderFns } from "./DesignStudioV3.vue?vue&type=template&id=8f629bba&scoped=true"
import script from "./DesignStudioV3.vue?vue&type=script&lang=js"
export * from "./DesignStudioV3.vue?vue&type=script&lang=js"
import style0 from "./DesignStudioV3.vue?vue&type=style&index=0&id=8f629bba&prod&scoped=true&lang=css"
import style1 from "./DesignStudioV3.vue?vue&type=style&index=1&id=8f629bba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f629bba",
  null
  
)

export default component.exports